/*
 * 接口统一集成模块
 */
import login from './apiModules/loginAPI';
import home from './apiModules/homeAPI';
import sbgl from './apiModules/sbgl';
import search from './apiModules/search';
import mngm from './apiModules/mngm';
import yjbk from './apiModules/yjbk';
import tjfx from './apiModules/tjfx';
import xtgl from './apiModules/xtgl';
// 多个页面接口集成
export default {
  ...login,
  ...home,
  ...sbgl,
  ...search,
  ...mngm,
  ...yjbk,
  ...tjfx,
  ...xtgl,
}


// WEBPACK FOOTER //
// ./src/http/apiList.js